import React from "react";
import { useContext, useEffect } from "react";
import { withRouter, useHistory, Link } from "react-router-dom";
import config from "./../../services/config.json";
import SimpleContext from "./../context/SimpleContext";
import { Button, Row, Modal } from "react-bootstrap";
import { useState } from "react";
import Preloader from "../Preloader/preloader3";
import { browserName, browserVersion } from "react-device-detect";
const Register = () => {
  const context = useContext(SimpleContext);
  const history = useHistory();
  const [hi, setHi] = useState([]);
  const [calldata, setcalldata] = useState(false);

  useEffect(() => {
    // setcalldata(true)
    // clearData()
    setHi([]);
  }, []);
  // const clearData = () => {
  //   if(calldata===true){
  //     localStorage.clear();
  //     window.location.reload();
  //     setcalldata(false)
  //   }
  // }
  // این تابع برای بررسی طول آرایه شماره همراه نوشته شده  و نهایتا تا اندازه اتریبیوت maxLength کاراکتر قبول میکند و بعد غیرفعال میشود.
  // function maxLengthCheck(object) {
  //   if (object.value.length > object.maxLength)
  //     object.value = object.value.slice(0, object.maxLength);
  // }

  const checkcustomer = (event) => {
    event.preventDefault();
    let MyTime = Date.now();
    let TimeHeader = context.Encriptor(MyTime + context.timeMiliSecondDef);

    const myheaders = {
      "atu-token": TimeHeader,
    };
    context.setpreButton(true);
    async function getData() {
      const url = `${context.baseUrlApiPakhsh}${config.customerCheck}`;
      const formData = new FormData();
      formData.append("appTypeId", context.AppType);
      formData.append("mobile", hi);
      formData.append("appVersion", browserName);
      formData.append("AndroidVersion", browserVersion);
      formData.append("deviceId", context.UniqueUUID);
      formData.append(
        "customerId",
        Object.values(context.UseInFo).length > 0 && context.UseInFo.customerId
      );
      const param = {
        method: "post",
        body: formData,
        headers: myheaders,
      };
      const sendRequest = await fetch(url, param);
      const response = await sendRequest.json();
      return response;
    }
    try {
      getData().then((data) => {
        context.setpreButton(false);
        if (data.popUp !== null) {
          if (data.popUp.text === "" && data.popUp.imageLink === "") {
            window.open(data.popUp.link, "noopener,noreferrer");
          } else {
            context.setmodalPopUp(true);
            context.setTextPopUp(data.popUp);
          }
        } else {
          context.setmodalPopUp(false);
        }
        if (data.code === 404) {
          context.setpreButton(false);
          context.seterrorshow(true);
          context.seterrorText(data.message);
          context.notExistCustomer();
        } else if (data.code === 200) {
          context.setUseInFo(data.response);
          context.setpreButton(false);
          history.push("/userCode");
          context.sendCode(data.response.customerId);
          // if(data.response.hasPassword===false){
          //     context.setpreButton(false)
          //     history.push("/userCode")
          //     context.sendCode()
          // }else if(data.response.hasPassword===true){
          //   context.setpreButton(false)
          //   history.push("/loginWithCode")
          // }
        }
      });
    } catch (ex) {
      console.log(ex);
    }
  };

  const handleChange = (event) => {
    setHi(event.target.value);
  };

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        height: "100vh",
      }}
    >
      <form onSubmit={checkcustomer} className="EnterNumberMAin">
        <div className="registerRow1">
          <img
            alt="image"
            src="/images/CoverBack.jpg"
            className="registerbackground"
            style={{ padding: "0" }}
          />
          <img alt="image" src="/images/logo.png" className="registerapilogo" />
        </div>

        <div className="registerRow2">
          <div className="registerRow2">
            <div
              style={{ justifyContent: "flex-start" }}
              className="registerRow2Row1"
            >
              <p>به اَپی پخش خوش آمدید.</p>
            </div>
            <br />

            <div style={{ gap: "10px" }} className="registerRow2Row2">
              <div className="infodiv">
                <Link
                  to="/rulls"
                  style={{
                    fontWeight: "bold",
                    color: "#ff7014",
                    fontSize: "14px",
                    margin: "0",
                    textDecoration: "none",
                  }}
                >
                  قوانین و مقررات
                </Link>
              </div>
              <div className="infodiv">
                <p
                  style={{
                    margin: "0",
                    fontWeight: "bold",
                    color: "#000",
                    fontSize: "11px",
                  }}
                >
                  لطفا شماره همراهتان را وارد کنید تا کد فعال سازی برای شما
                  ارسال شود
                </p>
              </div>
              <input
                type="number"
                placeholder="شماره همراه"
                className="inputPhone"
                // oninput={() => maxLengthCheck()}
                // نهایتا تا 11 عدد میتوان وارد کرد.
                maxLength="11"
                // min="0"
                // max="9"
                onChange={handleChange}
              />
            </div>
            {/* اگر تعداد ارقام کمتر از 11 بود، دکمه ثبت و ادامه غیرفعال میشود در غیراینصورت اگر 11 عدد وارد شد، دکمه فعال خواهد شد. */}
            {context.preButton === true ? (
              <button type="button" className="EnterNumberButtonActivated">
                <Preloader />
              </button>
            ) : hi.length === 11 ? (
              <button type="submit" className="EnterNumberButtonActivated">
                ورود / ثبت نام
              </button>
            ) : (
              <button type="button" className="EnterNumberButton">
                ورود / ثبت نام
              </button>
            )}
          </div>
        </div>
      </form>
      <Modal style={{ marginTop: "50%" }} show={context.errorshow}>
        <div style={{ gap: "10px" }} className="styleByFlexC">
          <p
            style={{
              margin: "0",
              color: "#000",
              fontWeight: "bold",
              marginTop: "10px",
            }}
          >
            {context.errorText}
          </p>
          <section className="registerModalButton">
            <a
              style={{ textDecoration: "none" }}
              href={`tel:${context.notExistRes}`}
              className="registerModalButton"
            >
              تماس با پشتیبانی
            </a>
          </section>
          {/* <button className='registerModalButton'>
                تماس با پشتیبانی
             </button> */}
          <button
            style={{ marginBottom: "10px" }}
            onClick={() => context.seterrorshow(false)}
            className="registerModalButton"
          >
            خروج
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default Register;
